import VueRouter from 'vue-router'
import ProjectApp from './components/ProjectApp.vue'
import ActivityView from './components/ActivityViewer.vue'
import ActivityExpanded from './components/ActivityExpanded.vue'
import { URLParameterRange_ActivityType } from './channel.types'

const router = new VueRouter({
  mode: 'history',

  routes: [
    {
      path: '/c/:channelSlug',
      component: ProjectApp,
    },
    {
      path: '/c/:channelSlug/:rowId/:activityType/:activityId',
      component: ProjectApp,
    },
    {
      path: '/c/:channelSlug/:rowId/:activityType/:activityId/:activityPlay',
      component: ProjectApp,
    },
  ],

  //If we're going to an article, then there might be a position that the user has scrolled to.
  //This is because articles tend to be long and require a lot of scrolling. This is different than
  //regular activities which don't really have scrollable content. The activities take care of scrolling
  //on their own.
  scrollBehavior(to, from, savedPosition) {
    if (to.params.activityType == URLParameterRange_ActivityType.ARTICLE) {
      return savedPosition ? savedPosition : { x: 0, y: 0 }
    }
  },
})

export default router
